<script>
    import { apiURL } from '../../store.js'
    import Diagram from '../content-types/Diagram.svelte'

    const diagrams = fetch(`${apiURL}/api/v2/diagrams/`)
        .then(res => res.json())
        .then(obj => obj.items)
</script>

<div id="diagramsContent">
    {#await diagrams then diagrams}
        {#each diagrams as diagram}
            <Diagram {diagram} />
        {/each}
    {/await}
</div>

<style lang="scss">
    #diagramsContent {
        position: relative;
        top: 30px;
        left: 0;
        width: 100vw;
        bottom: 0;
        overflow: hidden;
        min-height: calc(100vh - 120px);
        padding-bottom: 3rem;
    }
</style>
